/* Allens Swimwear | Swim Club pages script (V4.8)
   Upload as assets/allens-swim-club.js and load it from theme.liquid (see instructions).
   Safe to load on every page: each block only runs if its page content is present. */

/* ---------- Swim Club Programme page: audience tabs + FAQ tabs ---------- */
(function () {
  var root = document.getElementById('acp-programme');
  if (!root) return;
  root.classList.add('acp-js');

  function tabset(tabs, onSelect) {
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      if (onSelect) onSelect(tab);
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) { e.preventDefault(); select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
    return select;
  }

  /* Audience: path cards and tabs stay in sync */
  var paths = Array.prototype.slice.call(root.querySelectorAll('.acp-path'));
  var selectAud = tabset(Array.prototype.slice.call(root.querySelectorAll('#how-it-works [role="tab"]')), function (t) {
    var id = t.id.replace('acp-tab-', '');
    paths.forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-aud') === id ? 'true' : 'false'); });
  });
  paths.forEach(function (p) {
    p.addEventListener('click', function (e) {
      e.preventDefault();
      selectAud(document.getElementById('acp-tab-' + p.getAttribute('data-aud')), false);
      document.getElementById('how-it-works').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  selectAud(document.getElementById('acp-tab-' + ({ '#club': 'existing', '#swimmer': 'swimmer', '#register': 'new', '#acp-panel-new': 'new', '#acp-panel-existing': 'existing', '#acp-panel-swimmer': 'swimmer' }[location.hash] || 'new')), false);

  /* FAQ tabs */
  var faqSelect = tabset(Array.prototype.slice.call(root.querySelectorAll('#faqs [role="tab"]')));
  faqSelect(document.getElementById('acp-ftab-clubs'), false);
})();

/* ---------- Partner Clubs page: search, sticky A to Z, mobile accordions ---------- */
(function () {
  var root = document.getElementById('acp-partners');
  if (!root) return;
  root.classList.add('acp-js');
  root.setAttribute('data-acp-script', '4.8');
  var input = document.getElementById('acp-club-search');
  var count = document.getElementById('acp-club-count');
  var empty = document.getElementById('acp-club-empty');
  var emptyQ = document.getElementById('acp-club-empty-q');
  var list = document.getElementById('club-list');
  var az = root.querySelector('.acp-az');
  var groups = Array.prototype.slice.call(root.querySelectorAll('.acp-group'));
  var links = Array.prototype.slice.call(root.querySelectorAll('.acp-az [data-letter]'));
  var total = root.querySelectorAll('.acp-group li').length;
  var mq = window.matchMedia('(max-width: 749px)');
  var letter = 'All';

  /* Keep the A to Z bar tucked under the theme's sticky header, whatever its height */
  /* Finds the bottom edge of whatever is pinned to the top of the screen (sticky or
     fixed header, nav bar, announcement bar), by looking at what is actually drawn
     there rather than relying on theme class names. Stacked bars are followed down. */
  function headerBottom() {
    var y = 0, x = Math.round(window.innerWidth / 2), guard = 0;
    while (guard++ < 5) {
      var found = y, els = document.elementsFromPoint ? document.elementsFromPoint(x, y + 1) : [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        while (el && el !== document.body && el !== document.documentElement) {
          if (root.contains(el)) break;
          var pos = getComputedStyle(el).position;
          if (pos === 'fixed' || pos === 'sticky') {
            var r = el.getBoundingClientRect();
            if (r.top <= y + 1 && r.bottom > y && r.height < 400 && r.width > window.innerWidth * 0.5) found = Math.max(found, r.bottom);
            break;
          }
          el = el.parentElement;
        }
      }
      if (found > y + 0.5) y = found; else break;
    }
    return Math.round(y);
  }
  var ticking = false;
  function updateOffset() {
    ticking = false;
    root.style.setProperty('--acp-sticky-top', headerBottom() + 'px');
  }
  function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(updateOffset); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  updateOffset();

  function scrollToEl(el) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerBottom() - az.offsetHeight - 12;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* Desktop: letter groups always open. Mobile: closed until opened. */
  function setGroupsForViewport() {
    groups.forEach(function (g) { g.open = !mq.matches; });
  }
  groups.forEach(function (g) {
    g.querySelector('summary').addEventListener('click', function (e) {
      if (!mq.matches) e.preventDefault();
    });
  });

  function render() {
    var raw = input.value.trim(), q = raw.toLowerCase();
    var active = q ? 'All' : (mq.matches ? 'All' : letter), shown = 0, present = {};
    groups.forEach(function (g) {
      var L = g.getAttribute('data-letter'), n = 0;
      Array.prototype.forEach.call(g.querySelectorAll('li'), function (li) {
        var match = !q || li.textContent.toLowerCase().indexOf(q) !== -1;
        if (match) present[L] = true;
        var show = match && (active === 'All' || active === L);
        li.hidden = !show;
        if (show) n++;
      });
      g.hidden = n === 0;
      if (mq.matches && q) g.open = n > 0;
      shown += n;
    });
    var pressed = mq.matches ? (q ? 'All' : letter) : active;
    links.forEach(function (a) {
      var L = a.getAttribute('data-letter');
      a.setAttribute('aria-pressed', L === pressed ? 'true' : 'false');
      if (L !== 'All') a.setAttribute('aria-disabled', present[L] ? 'false' : 'true');
    });
    empty.hidden = shown !== 0;
    emptyQ.textContent = raw;
    if (q) count.textContent = (shown === 1 ? '1 club matches' : shown + ' clubs match') + ' \u201c' + raw + '\u201d';
    else if (active === 'All') count.textContent = 'Showing all ' + total + ' partner clubs';
    else count.textContent = 'Showing ' + shown + ' clubs starting with ' + active + ' (of ' + total + ')';
  }

  input.addEventListener('input', function () {
    if (mq.matches && !input.value.trim()) groups.forEach(function (g) { g.open = false; });
    render();
  });

  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (a.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      letter = a.getAttribute('data-letter');
      input.value = '';
      if (mq.matches) {
        /* Mobile: open that letter's accordion, close the rest, and scroll to it */
        groups.forEach(function (g) { g.open = letter !== 'All' && g.getAttribute('data-letter') === letter; });
        render();
        var target = letter === 'All' ? list : document.getElementById('clubs-' + letter);
        if (target) scrollToEl(target);
      } else {
        /* Desktop: filter to that letter and bring the list into view */
        render();
        if (list.getBoundingClientRect().top < headerBottom() + az.offsetHeight) scrollToEl(list);
      }
    });
  });

  document.getElementById('acp-club-clear').addEventListener('click', function () {
    input.value = ''; letter = 'All'; setGroupsForViewport(); render(); input.focus();
  });

  var onChange = function () { letter = 'All'; setGroupsForViewport(); render(); queue(); };
  if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);

  setGroupsForViewport();
  render();
})();
